const allocation = `${process.env.VUE_APP_URL}/api/v1/allocation`;
const allocationCalculation = `${process.env.VUE_APP_URL}/api/v1/calculation`
const cost = `${process.env.VUE_APP_URL}/api/v1/cost`;
import { validateResponseError } from "@/store/utils.js";
import { forEach } from "postcss-rtl/lib/affected-props";
import i18n from "@/libs/i18n";

export default {
  namespaced: true,
  state: {
    management: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocation}/account-allocations/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: i18n.t("Account ID"),
          field: "source_ext_id",
        },
        {
          label: i18n.t("Account name"),
          field: "source_name",
        },
        {
          label: i18n.t("Cost Pool ID"),
          field: "destination_ext_id",
        },
        {
          label: i18n.t("Cost Pool name"),
          field: "destination_name",
        },
        {
          label: i18n.t("Alocation type"),
          field: "allocation_type",
        },
        {
          label: i18n.t("Percentage"),
          field: "percentage",
          symbol: "%",
          type: "number",
        },
        {
          label: "Driver",
          field: "cost_pool_driver_name",
        },
        {
          label: "",
          field: "manage",
        },
      ],
      rows: [],
      orderField: '',
      orderDict: {
        source_name: "source__name",
        "source_ext_id": "source__number",
        "destination_ext_id": "destination__identifier",
        "destination_name": "destination__name",
        "allocation_type": "allocation_type",
        "percentage": "percentage",
        "cost_pool_driver_name": "driver__name",
      },
    },
    source: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/account-results/by-source/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: i18n.t("Account name"),
          field: "source_name",
        },
        {
          label: i18n.t("Original amount"),
          field: "original_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: i18n.t("Allocated amount"),
          field: "allocated_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          sortable: false,
        },
        {
          label: i18n.t("Status"),
          field: "status",
          sortable: false,
        },
      ],
      rows: [],
      orderField: '',
      orderDict: {
        source_name: "source__name",
        original_amount: "source_amount",
        allocated_amount: "amount",
        status: "status"
      },
    },
    destination: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/account-results/by-destination/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: i18n.t("Cost Pool"),
          field: "destination_name",
        },
        {
          label: "Amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: i18n.t("Cost per Minute"),
          field: "cost_per_minute",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: true,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        }
      ],
      rows: [],
      orderField: '',
      orderDict: {
        destination_name: "destination__name",
        amount: "amount"
      },
    },
    aggregated: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/account-results/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: i18n.t("Source"),
          field: "source_name",
        },
        {
          label: i18n.t("Destination"),
          field: "destination_name",
        },
        {
          label: i18n.t("Allocated amount"),
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        }
      ],
      rows: [],
      orderField: '',
      orderDict: {
        source_name: "source__name",
        destination_name: "destination__name",
        amount: "amount"
      },
    },
    createAllocationData: {
      source: null,
      destination: null,
      percentage: 100,
      driver: null,
      type: "PERCENTAGE"
    },
    accountOptions: [],
    costPoolOptions: [],
    costPoolDriverValuesOptions: [],


    aggregatedAllocationResultsRows: [],
    aggregatedAllocationResultsColumns: [
      {
        label: "Source",
        field: "source_name",
      },
      {
        label: "Destination",
        field: "destination_name",
      },
      {
        label: "Allocated amount",
        field: "amount",
        type: 'number',
        formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
      }
    ],
    lastCalculation: [{
      calculation_id: null,
      finished_at: null,
      requested_by_user: null,
    }],
    debug: {
      mode: "logs",
      errors: [],
      logs: []
    }
  },
  getters: {
    getDebugData(state) {
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_OFFSET(state, data) {
      state[data.subStore].offset = state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength < 0 ? 0 : state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength
    },
    SET_ACCOUNT_OPTIONS(state, data) {
      state.accountOptions = data;
    },
    SET_COSTPOOL_OPTIONS(state, data) {
      state.costPoolOptions = data
    },
    SET_COSTPOOL_DRIVER_VALUES_OPTIONS(state, data) {
      state.costPoolDriverValuesOptions = data
    },
    SET_CREATE_ALLOCATION_DATA(state, data) {
      state.createAllocationData = data;
    },
    SET_ALLOCATION_PERCENTAGE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.percentage = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_DRIVER(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.driver = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_SOURCE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.source = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_DESTINATION(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.destination = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_TYPE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.type = data;
      state.createAllocationData = allocationData;
    },
    CLEAR_ALLOCATION_DATA(state) {
      state.createAllocationData = {
        source: null,
        destination: null,
        percentage: 100,
        type: "PERCENTAGE",
        driver: null
      };
    },
    SET_AGGREGATED_ALLOCATION_RESULTS(state, data) {
      state.aggregatedAllocationResultsRows = data;
    },
    SET_LAST_CALCULATION(state, data) {
      if (!data) {
        return;
      }
      state.lastCalculation = data;
    },
    CLEAR_RESULTS_DATA(state) {
      state.source.rows = [];
      state.destination.rows = [];
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },

    SET_COUNT(state, data) {
      state[data.subStore].count = data.count;
    },
    SET_NEXT(state, data) {
      state[data.subStore].nextUrl = data.next;
    },
    SET_PREVIOUS(state, data) {
      state[data.subStore].previousUrl = data.previous;
    },
    SET_CURRENT(state, data) {
      state[data.subStore].currentUrl = data.current;
    },
    SET_ROWS(state, data) {
      if (!data.rows) {
        return;
      }
      let copy = { ...state[data.subStore] }
      copy.rows = data.rows;
      state[data.subStore] = copy;
    },
    SET_COLUMNS_TDABC(state, data) {
      if (data.subStore === "destination") {
        const has_cost_per_minute = data.rows.some(item => "cost_per_minute" in item)
        if (has_cost_per_minute) {
          state[data.subStore].columns.forEach(element => {
            if (element.label == "Cost per Minute") { element.hidden = false }
          });
        }else{
          state[data.subStore].columns.forEach(element => {
            if (element.label == "Cost per Minute") { element.hidden = true }
          });
        }
      }
    },
    SET_PAGE_LENGTH(state, data) {
      state[data.subStore].pageLength = data.pageLength;
    },

    CLEAR_TABLE_DATA(state, data) {
      if (data.subStore) {
        state[data.subStore].rows = [];
      }
    },
    SET_ORDER_FIELD(state, data) {
      if (data.subStore && state[data.subStore].orderDict) {
        switch (data.orderType) {
          case 'asc':
            state[data.subStore].orderField = state[data.subStore].orderDict[data.orderField];
            break;
          case 'desc':
            let orderField = state[data.subStore].orderDict[data.orderField]
            state[data.subStore].orderField = orderField ? `-${orderField}` : null;
            break;
          default:
            state[data.subStore].orderField = null;
            break;
        }
      }
    },
    SET_DEBUG_LOGS(state, data) {
      state.debug.logs = data;
    },
    SET_DEBUG_ERRORS(state, data) {
      state.debug.errors = data;
    },
    SET_DEBUG_MODE(state, data) {
      state.debug.mode = data;
    },
  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId, subStore }) {
      console.log(subStore)
      if (subStore != "management" && state.lastCalculation.length == 0 && !state.lastCalculation.calculation_id) {
        return;
      }
      let order = state[subStore].orderField ? `&ordering=${state[subStore].orderField}` : ''
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      let getData =
        state[subStore].currentUrl || state[subStore].baseUrl({ scenario: scenarioId, limit: state[subStore].pageLength, calculationId: state.lastCalculation.calculation_id, order: order, offset: offset });
      return context.$http.get(getData).then((res) => {
        commit("SET_COUNT", { subStore, count: res.data.count });
        commit("SET_NEXT", { subStore, next: res.data.next });
        commit("SET_PREVIOUS", { subStore, previous: res.data.previous });
        commit("SET_ROWS", { subStore, rows: res.data.results ? res.data.results : res.data });
        if(subStore == "destination") commit("SET_COLUMNS_TDABC", {subStore, rows: res.data.results})
      });
    },
    setNextAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].nextUrl });
    },
    setPreviousAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].previousUrl });
    },
    getAccounts({ commit }, { context, scenarioId, searchData }) {
      //Get account values
      let getUrl = `${cost}/account-values/?scenario=${scenarioId}&search=${searchData}`;
      return context.$http.get(getUrl)
        .then((res) => {
          let accountValues = [...res.data];
          commit("SET_ACCOUNT_OPTIONS", accountValues);
        });
    },
    getCostPools({ commit }, { context, scenarioId }) {
      let getUrl = `${cost}/pools/?scenario=${scenarioId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_COSTPOOL_OPTIONS", res.data);
        });
    },
    getCostPoolDriver({ commit }, { context, modelId }) {
      let getUrl = `${cost}/pool-drivers/?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_COSTPOOL_DRIVER_VALUES_OPTIONS", res.data);
        });
    },
    createUpdateFirstAllocation({ state }, { context, mode, scenarioId }) {
      let dataToPost = { ...state.createAllocationData };
      dataToPost.ratio = (dataToPost.percentage / 100).toFixed(6);

      dataToPost.source = state.accountOptions.filter(acc => acc.account_number == dataToPost.source)[0].account;
      dataToPost.destination = state.costPoolOptions.filter(cp => cp.identifier == dataToPost.destination)[0].id;

      dataToPost.scenario = scenarioId;

      if (mode == "UPDATE") {
        let putUrl = `${allocation}/account-${state.createAllocationData.type.toLowerCase()}-allocations/${state.createAllocationData.id}/`;
        return context.$http.patch(putUrl, dataToPost);
      }
      let postUrl = `${allocation}/account-${state.createAllocationData.type.toLowerCase()}-allocations/`;
      return context.$http.post(postUrl, dataToPost);
    },
    deleteFirstAllocation({ state }, { context, id, type }) {
      let deleteUrl = `${allocation}/account-allocations/${id}`;
      return context.$http.delete(deleteUrl);
    },
    //RESULTS
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACCOUNT_TO_COST_POOL`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if (res.data[res.data.length - 1].calculation_status !== "FINISHED") {
            throw new Error("No calculation");
          }
        })
        .catch(err => {
          validateResponseError(this, err, "firstAllocation");
        })
    },
    getLastCalculation({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=ACCOUNT_TO_COST_POOL`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if (res.data[res.data.length - 1].calculation_status !== "FINISHED") {
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "firstAllocation");
        })
    },
    calculateResults({ dispatch, commit }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/account-results/generate/`;
      return context.$http.post(resultsUrl, { scenario: scenarioId })
        .then(res => {
          commit("SET_LAST_CALCULATION", [res.data])
        });
    },
    getSourceAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "source", scenarioId: scenarioId })
    },
    getDestinationAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "destination", scenarioId: scenarioId })
    },
    getAggregatedAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "aggregated", scenarioId: scenarioId })
    },
    getCalculationLogs({ commit, state }, { context }) {
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/calculation/logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail)
        }).catch(err => {
          validateResponseError(this, err, "firstAllocation");
        })
    },
    getCalculationErrors({ commit }, { }) {
      commit("SET_DEBUG_ERRORS", ["Not implemented"]);
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/calculations/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
        .then(() => {
          return dispatch("getLastCalculationDetails", { context: context, scenarioId: scenarioId })
        });
    },
  },
}
